// extracted by mini-css-extract-plugin
export default {"FooterSection":"FooterSection_FooterSection__yCmAp","Stack":"FooterSection_Stack__YGIWy","MapImage":"FooterSection_MapImage__dT0Yx"};